//
//
//
//
//
//
//
//
//

// 公有组件
import navHeader from '$components/navHeader'
import navBar from '$components/navBar'
import navFooter from '$components/navFooter'

export default {
  components: {
    navHeader,
    navFooter,
    navBar
  },
}




// WEBPACK FOOTER //
// ./src/components/App.vue